import {
  ConfigProps,
  Product,
  ProductListConfig,
  ResultsInfo,
} from "../types/types";
import * as layouts from "./index";
import React from "react";

type Layout = (props: {
  products: Product[];
  config: ProductListConfig;
  configProps: ConfigProps;
  resultsInfo: ResultsInfo;
}) => React.ReactNode;

type LayoutMap = { [name: string]: Layout };

export const layoutMap: LayoutMap = layouts;
